import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { I18nextProvider } from 'react-i18next';

import './index.css';

import { bootstrap, currentHost, i18n, queryClient } from '@saas-kit/lib';
import { Toaster } from '@saas-kit/ui';

import { AdminRoutes } from './AdminRoutes';
import { WrongHost } from './WrongHost';

// Default the admin SPA to the dark palette on first visit. The shell's
// ThemeToggle still flips through light/dark/system as usual; we only
// pre-seed when the user hasn't expressed a preference yet.
try {
  if (!window.localStorage.getItem('saas-starter.theme')) {
    window.localStorage.setItem('saas-starter.theme', 'dark');
    document.documentElement.classList.add('dark');
  }
} catch {
  /* private mode — ignore */
}

const expectedHost = (import.meta.env.VITE_OPS_HOST ?? 'ops.kit.local').toLowerCase();
const onCorrectHost = currentHost() === expectedHost;

if (onCorrectHost) {
  void bootstrap();
}

const root = createRoot(document.getElementById('root')!);
root.render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Toaster />
          <div className="app-platform h-full">
            {onCorrectHost ? <AdminRoutes /> : <WrongHost expected={expectedHost} />}
          </div>
        </BrowserRouter>
      </QueryClientProvider>
    </I18nextProvider>
  </StrictMode>,
);
